/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PurchaseCreditsBody = zod
	.object({
		amount_usd: zod.string().describe('Amount in USD to purchase'),
		client_request_id: zod
			.uuid()
			.describe('Client-supplied idempotency key for this purchase attempt')
	})
	.describe('Purchase prepaid credits');

export type PurchaseCreditsBody = zod.input<typeof PurchaseCreditsBody>;
export type PurchaseCreditsBodyOutput = zod.output<typeof PurchaseCreditsBody>;
